import { defineRouting } from "next-intl/routing";

/**
 * Configuración central de i18n.
 * - Locales: `es` (default) y `en`.
 * - Routing por prefijo: SIEMPRE hay prefijo en la URL (`/es/...`, `/en/...`).
 *   Esto es requisito de arquitectura (SEO bilingüe con hreflang, principio 6).
 *
 * Para agregar un locale nuevo: añadir el código acá y crear su carpeta en
 * `messages/<locale>/` con los 5 archivos de área.
 */
export const routing = defineRouting({
  locales: ["es", "en"],
  defaultLocale: "es",
  // "always" => el default también lleva prefijo (/es). Mejor para hreflang y
  // para que las 4 superficies compartan la misma forma de URL.
  localePrefix: "always",
});

export type Locale = (typeof routing.locales)[number];
